import React from 'react'

import CloseIcon from '../../../assets/icons/close.svg?react'

type Props = { children: React.ReactNode, onClose: () => void, showCloseIcon?: boolean }
const SideDrawer: React.FC<Props> = ({ children, onClose, showCloseIcon }) => {
  return (
    <div className='w-screen h-screen bg-gray/50 backdrop-opacity-50 fixed top-0 right-0 z-40 no-doc-scroll'>
      <div className='w-screen h-full absolute top-0 right-0 z-50' onClick={onClose}></div>
      <div className='p-3 max-w-[90dvw] h-screen overflow-y-auto rounded-t-lg absolute bg-gray-300 bottom-0 right-0 z-50'>
        {showCloseIcon && (<CloseIcon onClick={onClose} className='cursor-pointer w-6 h-6 stroke-black absolute right-4 top-4' />)}
        {children}
      </div>
    </div>
  )
}

export default SideDrawer
